export default "__VITE_ASSET__vA2ieuzV__"